import type { KeySource } from './types';

/**
 * Serializes a key source into a string representation.
 * @param k The key source to serialize.
 * @returns The serialized key as a string, or undefined if the key source is invalid.
 */
export function serializeKey(k: KeySource | undefined) {
  if (typeof k === 'string') return k;
  if (typeof k === 'object' && k)
    return Object.entries(k)
      .sort(([ka], [kb]) => ka.localeCompare(kb))
      .flat()
      .join();

  return undefined;
}
